import { Stack, Typography } from '@mui/material';
import {
  AppRoutes,
  logUserActivity,
  RouteName,
  useAppDispatch,
  UserActivityAction,
  UserActivityActionSummary,
  UserActivityPageName,
} from 'common';
import { recipesSlice } from 'common/src/store/recipes';
import { CfBreadcrumbs } from '../../../cf-ui/Breadcrumbs/CfBreadcrumbs';
import { CfTabs } from '../../../cf-ui/Tabs/CfTabs';
import { useRouteChangeCleanup } from '../../../hooks/useRouteChangeCleanup';
import { StyledViewBox } from '../../_shared/components/shared-styled-components.styles';
import HiddenRecipes from './tabs/HiddenRecipes';
import LocationsAndRecipeEditors from './tabs/LocationsAndRecipeEditors';
import SecretRecipes from './tabs/SecretRecipes';
import { useEffect } from 'react';
import { getResolution } from '../../../utilities/resolution';

export default function ManageAccess(): JSX.Element {
  const dispatch = useAppDispatch();
  const manageAccessTabs = [
    {
      label: 'Locations & recipe editors',
      children: <LocationsAndRecipeEditors />,
      dataTestId: 'profile-tab',
    },
    {
      label: 'Hidden recipes',
      children: <HiddenRecipes />,
      disabled: false,
    },
    {
      label: 'Secret recipes',
      children: <SecretRecipes />,
      disabled: false,
    },
  ];

  useRouteChangeCleanup((routeName) => {
    if (![RouteName.ManageAccess].includes(routeName)) {
      dispatch(recipesSlice.actions.resetManageAccess());
    }
  });

  useEffect(() => {
    dispatch(
      logUserActivity({
        action: UserActivityAction.Visit,
        pageName: UserActivityPageName.ManageRecipeAccess,
        actionSummary: UserActivityActionSummary.VisitedManageRecipeAccess,
        resolution: getResolution(),
      })
    );
  }, []);

  return (
    <StyledViewBox>
      <CfBreadcrumbs
        breadcrumbs={[
          {
            routeName: RouteName.RecipeDashboard,
            displayName: AppRoutes[RouteName.RecipeDashboard].DisplayName,
          },
          {
            routeName: RouteName.ManageAccess,
            displayName: AppRoutes[RouteName.ManageAccess].DisplayName,
          },
        ]}
      />
      <Stack sx={{ padding: 2, background: 'white' }}>
        <Typography variant='h1' sx={{ mb: 2, px: 2 }}>
          Manage access
        </Typography>
        <CfTabs
          tabs={manageAccessTabs}
          variant='scrollable'
          scrollButtons='auto'
          containerSx={{
            width: '100%',
            px: 2,
          }}
          hideDivider
        />
      </Stack>
    </StyledViewBox>
  );
}
